// 1. Enhanced useGHNStore.js
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import {
  getCity,
  getDistrictByProvinceID,
  getWardByDistrictID,
} from "../../services/GHN/GHNService";

const useGHNStore = create((set, get) => ({
  // Danh sách tỉnh/thành phố
  provinces: [],
  // Danh sách quận/huyện
  districts: [],
  // Danh sách phường/xã
  wards: [],

  // Lựa chọn hiện tại
  selectedProvince: null,
  selectedDistrict: null,
  selectedWard: null,

  // Transform dữ liệu từ API thành format chuẩn
  transformProvince: (item) => {
    return {
      id: item.ProvinceID,
      name: item.ProvinceName,
      code: item.Code,
    };
  },

  transformDistrict: (item) => {
    return {
      id: item.DistrictID,
      name: item.DistrictName,
      provinceId: item.ProvinceID,
    };
  },

  transformWard: (item) => {
    return {
      id: item.WardCode,
      name: item.WardName,
      districtId: item.DistrictID,
    };
  },

  // Lấy danh sách tỉnh/thành phố
  fetchProvinces: async () => {
    try {
      const response = await getCity();

      if (response.code === 200 && response.message === "Success") {
        const provinces = response.data.map(get().transformProvince);
        set({ provinces });
        return provinces;
      }
    } catch (error) {
      console.error("Error fetching provinces:", error);
      return [];
    }
  },

  // Lấy danh sách quận/huyện theo tỉnh
  fetchDistricts: async (provinceId) => {
    try {
      const response = await getDistrictByProvinceID(provinceId);

      if (response.code === 200 && response.message === "Success") {
        const districts = response.data.map(get().transformDistrict);
        set({
          districts,
          // Reset ward khi thay đổi quận/huyện
          wards: [],
          selectedWard: null,
        });
        return districts;
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
      return [];
    }
  },

  // Lấy danh sách phường/xã theo quận/huyện
  fetchWards: async (districtId) => {
    try {
      const response = await getWardByDistrictID(districtId);

      if (response.code === 200 && response.message === "Success") {
        const wards = response.data.map(get().transformWard);
        set({ wards });
        return wards;
      }
    } catch (error) {
      console.error("Error fetching wards:", error);
      return [];
    }
  },

  // Chọn tỉnh/thành phố
  selectProvince: (province) => {
    set({
      selectedProvince: province,
      selectedDistrict: null,
      selectedWard: null,
      districts: [],
      wards: [],
    });

    // Tự động fetch districts khi chọn province
    if (province?.id) {
      get().fetchDistricts(province.id);
    }
  },

  // Chọn quận/huyện
  selectDistrict: (district) => {
    set({
      selectedDistrict: district,
      selectedWard: null,
      wards: [],
    });

    // Tự động fetch wards khi chọn district
    if (district?.id) {
      get().fetchWards(district.id);
    }
  },

  // Chọn phường/xã
  selectWard: (ward) => {
    set({ selectedWard: ward });
  },

  // Reset tất cả lựa chọn
  resetSelection: () => {
    set({
      selectedProvince: null,
      selectedDistrict: null,
      selectedWard: null,
      districts: [],
      wards: [],
    });
  },

  // Lấy địa chỉ đầy đủ dưới dạng string
  getFullAddress: () => {
    const { selectedProvince, selectedDistrict, selectedWard } = get();
    const parts = [];

    if (selectedWard) parts.push(selectedWard.name);
    if (selectedDistrict) parts.push(selectedDistrict.name);
    if (selectedProvince) parts.push(selectedProvince.name);

    return parts.join(", ");
  },
}));

export default useGHNStore;
